// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"334":"1b9ab144c46a0a3327f0","666":"48a9a0448ea96ae20351","774":"fda51c501567b45758a6"}[chunkId] + ".js";
};